// Which report types get the per-question "Question Breakdown" (what the rep
// actually said, the points hit and missed, the score per question) and
// which of those may push a question into the company's Q&A library.
//
// The breakdown was gated to Messaging Defense and Live Meeting only, so
// Objection Handling and Document Defense reps saw just the coach rows even
// though the backend stores the same per-question analysis for them (review,
// 2026-09-04; Toby: extend it). The library action stays with the two types
// whose questions are NEW to the company: Objection Handling's questions
// already ARE the library, and Document Defense questions belong to one
// document.

const BREAKDOWN_TYPES = ['Messaging Defense', 'Live Meeting', 'Objection Handling', 'Document Defense'];
const LIBRARY_SAVE_TYPES = ['Messaging Defense', 'Live Meeting'];

export const showsQuestionBreakdown = (sessionType) => BREAKDOWN_TYPES.includes(sessionType);

export const canSaveQuestionToLibrary = (sessionType) => LIBRARY_SAVE_TYPES.includes(sessionType);
